<template  >
  <main class="big-container">
  <section  class="agreement-container" :style="[agreementContainerStyle ,isPreview?{width:'80%',margin: '50px auto'}:{}, isPdf?'':boxShadowStyle  ]">
    <div class="agreement-info" :style="agreementInfoStyle">
  <h3 >{{title}}</h3>
  <h4 >לקוח - {{owner.name}}</h4>
<h4 v-if="signatureBase">מספר הסכם 00001</h4>
  <hr>

      <div class="property-info" :style="textAlignRight">
        <h4  :style="pTitlesStyle">כתובת:</h4>
        <h5 :style="pValuesStyle">  {{owner.address}}</h5>

        <h4  :style="pTitlesStyle" v-if="sell.isSelling">	מחיר מכירה מבוקש: ({{sell.type}})</h4>
        <h5 :style="pValuesStyle" v-if="sell.isSelling">{{formatNumber(sell.commision)}}</h5>

        <h4  :style="pTitlesStyle" v-if="rent.isRent">	מחיר שכירות מבוקש: ({{rent.type}})</h4>
        <h5 :style="pValuesStyle" v-if="rent.isRent">{{formatNumber(rent.commision)}}</h5>

        <h4  :style="pTitlesStyle" v-if="exclusivity.isExclus">אקסלוסיביות:</h4>
        <h5  :style="pValuesStyle" v-if="exclusivity.isExclus">{{formatExclus}}</h5>

        <h4  :style="pTitlesStyle" >סוג:</h4>
        <h5 :style="pValuesStyle">דירה</h5>


      </div>
  <hr>
  <div class="agreement-rules" :style="agreementRulesStyle">
    <h5 v-if="coopType==='b2b'"><span :style="makeItBold">סוג השת"פ:</span> מתווך הקונה יעביר למתווך המוכר {{b2b.value}} {{b2b.type}}</h5>
    <h5 v-if="coopType==='single'"><span :style="makeItBold">סוג השת"פ:</span>  כל אחד מהלקוח שלו: (כל מתווך גובה מהלקוח שלו, את מה שסיכם עם הלקוח שלו)</h5>
    <h5 v-if="coopType==='cooperate'"><span :style="makeItBold">סוג השת"פ:</span> קופה משותפת (מחברים יחד את עמלת המוכר, ואת עמלת הקונה, וכל מתווך מקבל חצי)</h5>
    <p :style="{margin:'0'}" v-for="(rule,idx) in rules" :key="idx">{{rule}}</p>
  </div>
  <div class="comments" v-if="options.comments" :style="{textAlign:center}">
    <hr>
    <h4>הערות:</h4>
    <p>{{options.comments}}</p>
  </div>
</div>
    <hr>
    <div class="date-and-signature" v-if="signatureBase" :style="dateAndSignatureStyle">
      <p>{{getTimeStr}}</p>
      <img class="the-signature" :src="signatureBase" alt="חתימת הלקוח" :style="getSignatureStyle">
    </div>
    <div v-if="isPreview && !isPdf" class="btns-section" :style="btnsSectionStyle" >
    <button class="btn btn-primary" hidden @click="onShowForm()">חזור אחורה</button>
      <button v-if="!signatureBase"  @click="toSignature()" class="btn btn-success">המשך לחתימה</button>
      <button v-if="signatureBase" @click="postTheForm()" class="btn btn-success">שלח טופס</button>
    </div>



  </section>
  </main>
</template>

<script>
// import VueHtml2pdf from 'vue-html2pdf'
export default {
  name: "agreement-preview",
  props:["rent","sell","owner","exclusivity","options","signatureBase","isPreview","isPdf","documentType","b2b","coopType"],
  data(){
    return{
      rules:["1. הלקוח מצהיר בזאת כי הינו המחזיק החוקי ובעל הזכויות המלאות והחוקיות בנכס המקרקעין המתואר בנספח להלן והמהווה חלק בלתי נפרד מהסכם זה (להלן: \"הנכס\") או שהינו מורשה מטעם בעל/י הזכויות למוכרו ו/או להשכירו ו/או למסרו בדמי מפתח. הלקוח מצהיר כי הובהר לו כי פרטי הנכס יועמדו לידיעת קונים/שוכרים/מתווכים כדי לקדם את שיווק הנכס וכן שפרטי הנכס שמסר למתווך והרשומים בנספח הינם הפרטים המהותיים, הנכונים והמלאים.",
        "2. הלקוח מתחייב להמציא למתווך מידית נסח רישום או אישור זכויות מרשות מקרקעי ישראל ו/או החברה המשכנת, עדכניים.",
        "3. הלקוח ישלם למתווך עבור פעולת התיווך, מיד עם חתימת הסכם מחייב למכירת או השכרת הנכס בשיעורים המפורטים בסעיף 4 להלן.",
        "4. דמי התיווך שהלקוח מתחייב בזה לשלמם בהתאם לאמור בסעיף 3 לעיל ישולמו במזומן כדלקמן:",
        "4.1 במכירה : 2 אחוז ממחיר המכירה כקבוע בהסכם המכר של הנכס בתוספת מע\"מ.",
        "4.2 בהשכרה : דמי שכירות 1 חודשי שכירות (ללא קשר לתקופת השכירות) בתוספת מע\"מ.",
        "4.3 אין באמור לעיל כדי לגרוע מזכותו של המתווך לגבות דמי תיווך מהקונה/שוכר.",
        "5. הלקוח מאשר שהומלץ לו על ידי המתווך להסתייע בשירותי עורך דין ו/או מומחים אחרים לפי העניין והצורך במהלך העסקה.",
        "6. הלקוח מצהיר כי ידוע לו כי דמי התיווך ייגבו ע\"י המתווך וכנגד חשבונית מס כחוק מטעם המתווך.",
        "7. שום ויתור, ארכה, הנחה או שינוי בתנאי כלשהוא בהסכם זה, לא יהיו בני תוקף, אלא אם יעשו בכתב. שום איחור בשימוש בזכויותיו של צד כלשהוא לא ייחשב כויתור והוא יהיה רשאי להשתמש בזכויותיו כולן או בכל אחת מהן לחוד, הן לפי הסכם זה והן לפי כל דין, בכל עת שימצא לנכון.",
        "8. יחידי הצדדים יהיו אחראים על פי הסכם זה ביחד ולחוד. כל אימת שאחד מיחידי הצדדים יחתום על כל מסמך, כתב, מכתב, או אישור מכל סוג שהוא בכל עניין ודבר הקשור בהסכם זה, ביצועו או הנובע הימנו, תחייב חתימתו את יתר יחידי אותו צד.\n",
        ],
      title:'הזמנת שירותי תיווך למכירת ו/או השכרת  נכס-מקרקעין'
    }
  },
  methods:{
    onShowForm(){
      this.$emit("onShowForm")
    },
    formatNumber(num) {
      if(this.rent.isRent&& this.rent.type==="₪" ||this.sell.isSelling&& this.sell.type==="₪") return Intl.NumberFormat('il-IL',{style:'currency',currency:'ILS',maximumSignificantDigits:15}).format(num)
      else return Intl.NumberFormat('il-IL',{maximumSignificantDigits:15}).format(num)
    },
    toSignature(){
      this.$emit("toSignature")
    },
    postTheForm(){
      this.$emit("download")
    }
  },
  created() {
  },
  mounted() {
    switch (this.documentType){
      case"interested":
        this.rules=[
            "1. הלקוח מזמין שרותי תיווך מקרקעין מהמתווך, כדי לקבל שרותי תיווך בקשר לנכסים המפורטים לעיל.\n",
            "2. הלקוח מאשר כי המתווך הציג בפניו את הנכסים המפורטים להלן, והוא מתחייב לדווח למתווך מיד על כל משא ומתן המתנהל עמו ו/או עם שולחו בקשר לאחד או יותר מהנכסים, וכן מיד עם חתימת הסכם מחייב ו/או התחייבות לביצוע העסקה, המוקדם מביניהם, ביחס לאחד או יותר מהנכסים להלן.\n",
            "3. למען הסר ספק, הלקוח מצהיר כי מובן לו וכי הוא מסכים, כי כל הסכם אשר ייחתם בין הלקוח ו/או מי מטעמו לבין בעל הנכס, בנוגע לכל אחד מהנכסים המפורטים מטה, יחייב את הלקוח בדמי התיווך כמפורט בסעיף 5 להלן.\n",
            "4. הלקוח מתחייב לא למסור לגורם כלשהו מידע שקיבל מהמתווך בנוגע לנכסים שלהלן ומתחיב לפצות את המתווך על כל נזק שייגרם לו באם יפר התחייבות זו.\n",
            "5. הלקוח מתחייב לשלם למתווך את דמי התיווך כמפורט להלן, מיד עם חתימת הסכם מחייב או עם התחייבות לביצוע העסקה, המוקדם מביניהם, בנוגע לאחד או יותר מהנכסים המפורטים להלן.\n" +
            "דמי התיווך ישולמו במזומן כדלקמן :",
            "5.1. בקנייה: 2 אחוז ממחיר הקנייה הכולל של הנכס בתוספת מע\"מ.\n",
            "5.2. בשכירות: דמי שכירות של 1 חודשי שכירות בתוספת מע\"מ.\n",
            "5.3. דמי התיווך ישולמו למתווך במזומן מיד עם חתימת הסכם מחייב ו/או עם התחייבות לביצוע העסקה, המוקדם מביניהם.\n",
            "5.4. האמור לעיל בא בנוסף לזכותו של המתווך לגבות דמי תיווך מהמוכר / המשכיר.\n",
            "6. הלקוח מאשר כי עם מכירת הנכס, המתווך יוכל להודיע לציבור כי הנכס נמכר בכל דרך שהמתווך ימצא לנכון.\n",
            "7. הלקוח מאשר שהומלץ לו על ידי המתווך להסתייע בשירותי עורך דין ו/או מומחים אחרים לפי העניין והצורך במהלך העסקה.\n",
            "8. שום ויתור, ארכה, הנחה או שינוי בתנאי כלשהוא בהסכם זה, לא יהיו בני תוקף, אלא אם יעשו בכתב. שום איחור בשימוש בזכויותיו של צד כלשהוא לא ייחשב כויתור והוא יהיה רשאי להשתמש בזכויותיו כולן או בכל אחת מהן לחוד, הן לפי הסכם זה והן לפי כל דין, בכל עת שימצא לנכון.",
            "9. יחידי הצדדים יהיו אחראים על פי הסכם זה ביחד ולחוד. כל אימת שאחד מיחידי הצדדים יחתום על כל מסמך, כתב, מכתב, או אישור מכל סוג שהוא בכל עניין ודבר הקשור בהסכם זה, ביצועו או הנובע הימנו, תחייב חתימתו את יתר יחידי אותו צד.",

        ]
        break;
        case "coop":
          this.rules=[
              "1 הצדדים יפעלו מתוך נאמנות, הגינות ושקיפות לשיתוף פעולה.",
              "2. הצדדים לא ימסרו את פרטי הנכס / הקונה למתווך אחר , אלא אם יקבלו אישור ובכתב.\n",
              "3 . כל קשר עם הקונה / בעל נכס יהיה באמצעות הנציג המייצג (אלא אם סוכם בכתב אחרת)\n",
              "4. הסכם זה תקף לגבי כל עסקה אשר תיווצר מהנכס הנ\"ל גם עם מעורבות מתווךנציג נוסף (צד ג').\n",
              "5. הסכם זה תקף על הנכסים הנ\"ל בלבד.\n",
              "6. לכל הסכומים המצויינים לעיל יתווסף מע\"מ כחוק.\n",
          ]
        break;
    }
  },
  computed:{
    formatExclus(){
      let exclusStr = ''
      let exclusFromStr = new Date(this.exclusivity.from).toLocaleDateString()
      let exclusToStr = new Date(this.exclusivity.to).toLocaleDateString()
      exclusFromStr = `מ - ${exclusFromStr} עד - ${exclusToStr}`
      return exclusFromStr;
    },
    getTimeStr(){
      const currentTime=new Date()
      const date = currentTime.toLocaleDateString()
      const hour = currentTime.getHours()
      let minutes = currentTime.getMinutes().toString()
      if(minutes.length<2) minutes = `0${minutes}`
       return `נחתם בתאריך ${date} ובשעה ${hour}:${minutes} `
    },
    agreementContainerStyle(){
      return {
        direction: "rtl",
        fontFamily: "Tahoma",
      margin: "0 auto",
      marginTop: "50px",
      textAlign: "center",
      width: "95%",
      // boxShadow: "0px 1px 4px #00000022",
      padding: "15px 30px",
      }
    },
    boxShadowStyle(){
      return{
        boxShadow: "0px 1px 4px #00000022",
      }
    },

    textAlignRight(){
      return {
        textAlign: "right"
      }
    },
    agreementInfoStyle(){
      return{

      }
    },
    h5Style(){
      return {
          // width: "190px",
          // margin: "0",
      }
    },
    propertyInfoStyle(){
      return {
      // display: "flex",
      // justifyContent: "space-between",
      // alignItems: "center",
      // marginBottom: "5px",
      }
    },
    pTitlesStyle(){
      return {
        textDecoration: "underline",
marginTop:"10px",
marginBottom:"10px",
        lineHeight:"1.1",
    }
    },
    pValuesStyle(){
      return {
marginTop:"10px",
marginBottom:"10px",
        lineHeight:"1.1",
        fontWeight:"400"
    }
    },
    agreementRulesStyle(){
      return {
        textAlign: "right",
      margin: "5px 0",
      fontSize: "12px",
      }
    },
    btnsSectionStyle(){
      return {
        marginTop: "25px",
      display: "flex",
      justifyContent: "space-between",
      }
    },
    dateAndSignatureStyle(){
      return {
        display: "flex",
        justifyContent: "space-between",
      }
    },
getSignatureStyle(){
      const screenWidth = window.screen.width
      let signatureWidth = "180px"
      if(screenWidth<550) {
        signatureWidth = "50px"
      }
      return {
        width: signatureWidth
      }
},
    makeItBold(){
      return {
        fontWeight:900
      }
    }

  }
};
</script>

<style scoped>
/*.agreement-container{*/
/*  direction: rtl;*/
/*  font-family: Tahoma;*/
/*  margin: 0 auto;*/
/*  margin-top: 50px;*/
/*  text-align: center;*/
/*  width: 80%;*/
/*  box-shadow: 0px 1px 4px #00000022;;*/
/*  background-color: #fafafa;*/
/*  padding: 15px 30px;*/
/*}*/

/*h5 {*/
/*  width: 190px;*/
/*  margin: 0;*/
/*}*/

/*.property-info{*/
/*  display: flex;*/
/*  justify-content: space-between;*/
/*  align-items: center;*/
/*  margin-bottom: 5px;*/
/*}*/
/*.agreement-rules{*/
/*  text-align: right;*/
/*  margin: 5px 0;*/
/*  font-size: 1.2rem;*/
/*}*/
/*.btns-section{*/
/*  margin-top: 25px;*/
/*  display: flex;*/
/*  justify-content: space-between;*/
/*}*/
/*.p-titles{*/
/*  text-decoration: underline;*/
/*}*/
/*.comments{*/
/*  text-align: right;*/
/*}*/
/*.date-and-signature{*/
/*  display: flex;*/
/*  justify-content: space-between;*/
/*}*/
/*.the-signature{*/
/*  width: 180px;*/
/*}*/
@media (max-width: 500px) {
  .the-signature{
    width: 50px;
  }

}
</style>